module.exports = __webpack_public_path__ + "static/img/5.cf7175e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/5.jpg
// module id = o7Pq
// module chunks = 5